/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Dl_Verify_DescInputs */

const en_wc_dl_verify_desc = /** @type {(inputs: Wc_Dl_Verify_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each release ships SHA256SUMS.txt. Compare it with the checksum of the file you downloaded:`)
};

/**
* | output |
* | --- |
* | "Each release ships SHA256SUMS.txt. Compare it with the checksum of the file you downloaded:" |
*
* @param {Wc_Dl_Verify_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_dl_verify_desc = /** @type {((inputs?: Wc_Dl_Verify_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Dl_Verify_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_dl_verify_desc(inputs)
});
export { wc_dl_verify_desc as "wc.dl.verify_desc" }